import { render, staticRenderFns } from "./CourseListing.vue?vue&type=template&id=b5b5c180&scoped=true"
import script from "./CourseListing.vue?vue&type=script&lang=js"
export * from "./CourseListing.vue?vue&type=script&lang=js"
import style0 from "./CourseListing.vue?vue&type=style&index=0&id=b5b5c180&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5b5c180",
  null
  
)

export default component.exports